import useAdminAnnouncementStore from '@/domains/admin/store/adminAnnouncement.store';
import AdminAnnouncementColorEnum from '@/domains/admin/typescript/AdminAnnouncementColorEnum';
import AdminAnnouncementIconEnum from '@/domains/admin/typescript/AdminAnnouncementIconEnum';
import AdminAnnouncementPageDisplayEnum from '@/domains/admin/typescript/AdminAnnouncementPageDisplayEnum';
import IconDownload from '@/domains/common/components/icons/IconDownload.vue';
import { checkPodonexVersion } from '@/domains/settings/utils/checkPodonexVersion';
import { t } from '@/translations';

const VERSION_ANNOUNCEMENT_ID = -2;

async function checkPodonexVersionAnnouncement() {
    const store = useAdminAnnouncementStore();
    const nextPodonexVersion = await checkPodonexVersion();
    if (!nextPodonexVersion) {
        store.removeAnnouncement(VERSION_ANNOUNCEMENT_ID);
        return;
    }
    if (hasVersionAnnouncement(store)) {
        return;
    }
    store.announcements.push({
        id: VERSION_ANNOUNCEMENT_ID,
        text: t('podonex_update_checker.text'),
        title: t('podonex_update_checker.title'),
        color: AdminAnnouncementColorEnum.SUCCESS,
        pictogram: AdminAnnouncementIconEnum.INFO,
        unclosable: true,
        pageToDisplay: AdminAnnouncementPageDisplayEnum.GLOBAL,
        isActivated: true,
        sideEffect: {
            label: t('podonex_update_checker.button_label'),
            effect: () => {
                const a = document.createElement('a');
                a.href = nextPodonexVersion.presignedUrl;
                a.click();
            },
            icon: IconDownload,
        },
        createdAt: new Date(),
        updatedAt: new Date(),
    });
}

function hasVersionAnnouncement(store: ReturnType<typeof useAdminAnnouncementStore>) {
    return store.announcements.some((announcement) => announcement.id === VERSION_ANNOUNCEMENT_ID);
}

export { checkPodonexVersionAnnouncement, VERSION_ANNOUNCEMENT_ID };
